import { authenticationService } from '../services/authenticationService';

export function handleResponse(response: any) {
    const data = response.data;
    const responseOK = response && response.status === 200 && response.statusText === 'OK';
    if (!responseOK) {
        if ([401, 403].indexOf(response.status) !== -1) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            authenticationService.logout();
            //location.reload(true);
        }

        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
    }

    return data;
}